
import { Component, Prop, Vue } from 'vue-property-decorator'
import MainLayoutHeader from '../components/MainLayoutHeader.vue'
import MainLayoutMenu from '../components/MainLayoutMenu.vue'
import MainLayoutUser from '../components/MainLayoutUser.vue'
import { SysMenuOutput as MenuTree } from '@/api/swagger'
import { useMenuStore } from '@/store/menu'
import { useReuseTabStore } from '@/store/reuse-tab'

@Component({
  name: 'BuildinLayoutTopLeftDouble',
  components: { MainLayoutHeader, MainLayoutUser, MainLayoutMenu },
})
export default class extends Vue {
  @Prop({ type: String })
  private theme!: 'light' | 'dark'

  // 是否顶部导航固定
  @Prop({ type: Boolean })
  private fixedHeader!: boolean

  // 是否左侧菜单
  @Prop({ type: Boolean })
  private fixedMenu!: boolean

  private menuStore = useMenuStore()
  private reuseTabStore = useReuseTabStore()

  /**
   * 顶级的所有菜单
   */
  private get topLevelMenus(): MenuTree[] {
    return this.menuStore.microMenus.map((v) => {
      const target = { ...v }

      delete target.children

      return target
    })
  }

  /**
   * 当前的顶级菜单
   */
  private get currentTopLevelMenu(): MenuTree | void {
    const record = this.reuseTabStore.matched[0]
    const menu = this.menuStore.microMenus.find((v) => v.link === record?.path)

    return menu
  }

  /**
   * 获取当前顶级菜单的子菜单
   */
  private get currentChildrenMenu(): MenuTree[] | void {
    const currentTop = this.currentTopLevelMenu

    if (!currentTop) {
      return []
    }
    return currentTop.children
  }

  protected get contentTop() {
    const breadHeight = this.$slots.bread ? 31 : 0
    const tabHeight = this.$slots.tab ? 52 : 0
    return this.fixedHeader ? breadHeight + tabHeight + 'px' : 0
  }
}
